<template>
  <div class="navDragMenu" v-if="postParams.navType === 'footer'">
    <div class="oh df">
      <div class="w800 mr10" v-if="menuList && menuList.length">
        <draggable
          class="wrapper df mr4 ml10"
          style="flex-wrap: wrap;"
          v-model="menuList"
          @start="drag = true"
          @end="onDragEnd"
          item-key="index"
        >
          <template #item="{ element, index }">
            <div
              :class="`footerCOntainer ${index === checkIndex ? 'active' : ''}`"
            >
              <div
                :class="`item df mb10 dragTitle`"
                @click="() => checkMenuTab(index)"
              >
                <a-tooltip>
                  <template #title>{{
                    [null, '', undefined].includes(element.menuName)
                      ? '一级菜单名称'
                      : element.menuName
                  }}</template>
                  <span
                    class="menuTit"
                    style="width:160px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block; padding-left: 25px;"
                  >
                    <lock-outlined
                      v-if="element.raceLock"
                      style="color: #ff0000;"
                    />
                    {{
                      [null, ''].includes(element.menuName)
                        ? '一级菜单名称'
                        : element.menuName
                    }}
                  </span>
                </a-tooltip>
                <span
                  class="mr4 cp icon"
                  @click="
                    () => {
                      checkMenuTab(index)
                      dealMenu(true, 1, 2, element)
                    }
                  "
                >
                  <edit-outlined />
                </span>
                <a-popconfirm
                  title="是否确认删除?"
                  ok-text="确认"
                  cancel-text="取消"
                  @confirm="() => removeMenu({ menuType: 1, index })"
                >
                  <span class="cp icon"><close-outlined /></span>
                </a-popconfirm>
              </div>
              <draggable
                class="wrapper"
                v-model="menuList[index].menuList"
                @start="drag = true"
                @end="drag = false"
                item-key="index"
                :options="{ handle: '.menuTit' }"
                ><template #item="{ element: item, index: key }">
                  <div
                    :key="key"
                    class="df dragTitle mb10"
                    @click="() => checkMenuTab(index)"
                  >
                    <a-tooltip v-if="item.menuCategory === 1">
                      <template #title>
                        {{
                          [null, '', undefined].includes(item.menuName)
                            ? '二级菜单名称'
                            : item.menuName
                        }}
                      </template>
                      <span
                        class="menuTit"
                        style="width:160px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-flex; align-items:center; padding-left: 25px; gap:8px;"
                      >
                        <img
                          v-if="
                            item.langs?.find(v => v.langCode === langCode)
                              ?.menuPic || item.menuPic
                          "
                          :src="
                            item.langs?.find(v => v.langCode === langCode)
                              ?.menuPic || item.menuPic
                          "
                          style="height:28px;width:auto;object-fit:cover;"
                        />
                        <lock-outlined
                          v-if="element.raceLock"
                          style="color: red;"
                        />
                        {{
                          [null, ''].includes(item.menuName)
                            ? '二级菜单名称'
                            : item.menuName
                        }}
                      </span>
                    </a-tooltip>
                    <div v-if="item.menuCategory === 2">
                      <img
                        :src="item.langs?.[0]?.menuPics?.[0]?.picUrl"
                        style="width: 160px;height: 40px;"
                        alt=""
                      />
                    </div>
                    <span
                      class="mr4 cp icon"
                      @click="
                        () => {
                          sonCheckIndex = key
                          dealMenu(true, 2, 2, item)
                        }
                      "
                    >
                      <edit-outlined />
                    </span>

                    <a-popconfirm
                      title="是否确认删除?"
                      ok-text="确认"
                      cancel-text="取消"
                      @confirm="
                        () => removeMenu({ menuType: 2, sonIndex: key })
                      "
                    >
                      <span class="cp icon"><close-outlined /></span>
                    </a-popconfirm>
                  </div>
                </template>
              </draggable>
              <div
                class="addPerMenu footer"
                @click="
                  () => {
                    checkIndex = index
                    dealMenu(true, 2, 1)
                  }
                "
              >
                + 添加二级菜单
              </div>
            </div>
          </template>
        </draggable>
      </div>
      <div
        class="pt10"
        v-if="!(postParams.navType === 'footer' && menuList.length > 3)"
        @click="
          () => {
            dealMenu(true, 1, 1)
          }
        "
      >
        <div class="addPerMenu footer">
          + 添加一级菜单
        </div>
      </div>
    </div>
  </div>
  <!-- 带图导航 || app -->
  <div
    class="navDragMenu"
    v-else-if="
      postParams.navType === 'header' &&
        (postParams.subChannel === 2 || postParams.subChannel === -1)
    "
  >
    <ImgMenuSet />
  </div>
  <div
    class="navDragMenu"
    v-else-if="
      // eslint-disable-next-line vue/no-dupe-v-else-if
      postParams.navType === 'header' &&
        postParams.subChannel === 2 &&
        postParams.navStyle === 0
    "
  >
    <TextMenuSet></TextMenuSet>
  </div>

  <div class="navDragMenu" v-else>
    <div class="oh df">
      <div
        class="dragTitles"
        style="max-width: 800px;"
        v-if="menuList && menuList.length"
      >
        <draggable
          class="wrapper df"
          v-model="menuList"
          @start="drag = true"
          @end="onDragEnd"
          item-key="index"
        >
          <template #item="{ element, index }">
            <div
              :class="
                `item df dragTitle ${index === checkIndex ? 'active' : ''}`
              "
              @click="() => checkMenuTab(index)"
            >
              <a-tooltip>
                <template #title>{{
                  [null, '', undefined].includes(element.menuName)
                    ? '一级菜单名称'
                    : element.menuName
                }}</template>
                <span
                  class="menuTit"
                  :style="
                    element.langs?.[0]?.menuPic || element.menuPic
                      ? {
                          width: '160px',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          display: 'inline-block',
                          paddingLeft: '25px',
                          backgroundImage: `url(${element.langs?.[0]?.menuPic ||
                            element.menuPic})`,
                          backgroundSize: '20px 20px',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: '0px center'
                        }
                      : {
                          width: '160px',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          display: 'inline-block',
                          paddingLeft: '25px'
                        }
                  "
                >
                  <lock-outlined
                    v-if="element.raceLock"
                    style="color: #ff0000;"
                  />

                  {{
                    [null, ''].includes(element.menuName)
                      ? '一级菜单名称'
                      : element.menuName
                  }}
                </span>
              </a-tooltip>

              <span
                class="mr4 cp icon"
                @click="
                  () => {
                    checkMenuTab(index)
                    dealMenu(true, 1, 2, element)
                  }
                "
                ><edit-outlined
              /></span>
              <a-popconfirm
                title="是否确认删除?"
                ok-text="确认"
                cancel-text="取消"
                @confirm="() => removeMenu({ menuType: 1, index })"
              >
                <span class="cp icon"><close-outlined /></span>
              </a-popconfirm>
            </div>
          </template>
        </draggable>
      </div>
      <div
        v-if="!(postParams.navType === 'footer' && menuList.length > 3)"
        class="addTab"
        @click="
          () => {
            dealMenu(true, 1, 1)
          }
        "
      >
        <plus-outlined />
      </div>
    </div>
    <div
      class="dragContainer df"
      v-if="checkIndex !== null && menuList && menuList.length"
    >
      <div
        style="overflow-x: scroll; width: 780px; margin-right: 20px;"
        v-if="
          menuList &&
            menuList[checkIndex] &&
            menuList[checkIndex].menuList &&
            menuList[checkIndex].menuList.length
        "
      >
        <draggable
          class="wrapper df"
          v-model="menuList[checkIndex].menuList"
          @start="drag = true"
          @end="drag = false"
          item-key="index"
        >
          <template #item="{ element, index: sonIndex }">
            <div :class="`item dragList`">
              <div class="mb4 dragPer df">
                <a-tooltip>
                  <template #title>{{
                    [null, '', undefined].includes(element.menuName)
                      ? '二级菜单名称111'
                      : element.menuName
                  }}</template>
                  <span
                    class="menuTit"
                    style="width:160px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block; padding-left: 25px;"
                  >
                    <lock-outlined
                      v-if="element.raceLock"
                      style="color: #ff0000;"
                    />
                    {{
                      [null, ''].includes(element.menuName)
                        ? '二级菜单名称'
                        : element.menuName
                    }}
                  </span>
                </a-tooltip>
                <span
                  class="mr4 cp icon"
                  @click="
                    () => {
                      sonCheckIndex = sonIndex
                      dealMenu(true, 2, 2, {
                        ...element,
                        canImg: element.menuType - 0 === 101 ? true : false
                      })
                    }
                  "
                  ><edit-outlined
                /></span>

                <a-popconfirm
                  title="是否确认删除?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="
                    () =>
                      removeMenu({
                        menuType: 2,
                        sonIndex
                      })
                  "
                >
                  <span class="cp icon" v-if="element.menuType - 0 !== 101"
                    ><close-outlined
                  /></span>
                </a-popconfirm>
              </div>
              <draggable
                class="wrapper"
                v-model="element.menuList"
                @start="drag = true"
                @end="drag = false"
                item-key="index"
              >
                <template #item="{ element: element_, index: gsIndex }">
                  <div class="item dragSon df">
                    <a-tooltip>
                      <template #title>{{
                        [null, '', undefined].includes(element_.menuName)
                          ? '三级菜单名称'
                          : element_.menuName
                      }}</template>
                      <span
                        class="menuTit"
                        style="width:160px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-flex; align-items:center; padding-left: 25px; gap:8px;"
                      >
                        <img
                          v-if="
                            element_.langs?.find(v => v.langCode === langCode)
                              ?.menuPic || element_.menuPic
                          "
                          :src="
                            element_.langs?.find(v => v.langCode === langCode)
                              ?.menuPic || element_.menuPic
                          "
                          style="height:28px;width:auto;object-fit:cover;"
                        />
                        <lock-outlined
                          v-if="element_.raceLock"
                          style="color: #ff0000;"
                        />
                        {{
                          [null, ''].includes(element_.menuName)
                            ? '三级菜单名称'
                            : element_.menuName
                        }}
                      </span>
                    </a-tooltip>
                    <span
                      class="mr4 cp icon"
                      @click="
                        () => {
                          gsCheckIndex = gsIndex
                          sonCheckIndex = sonIndex
                          dealMenu(true, 3, 2, element_)
                        }
                      "
                      ><edit-outlined
                    /></span>
                    <a-popconfirm
                      title="是否确认删除?"
                      ok-text="确定"
                      cancel-text="取消"
                      @confirm="
                        () =>
                          removeMenu({
                            menuType: 3,
                            sonIndex,
                            gsIndex
                          })
                      "
                    >
                      <span class="cp icon"><close-outlined /></span>
                    </a-popconfirm>
                  </div>
                </template>
              </draggable>
              <div
                v-if="
                  element.menuType - 0 !== 101 &&
                    postParams.navType === 'header'
                "
                class="addThreeLevel"
                @click="
                  () => {
                    sonCheckIndex = sonIndex
                    dealMenu(true, 3, 1)
                  }
                "
              >
                + 添加三级菜单
              </div>
              <div
                style="width: 100%; height: 100px; position: relative;"
                v-if="element.menuType - 0 === 101"
              >
                <div
                  v-if="!['', null].includes(element.menuPic)"
                  class="h100 pa l0 t0"
                >
                  <img
                    :src="element.menuPic"
                    alt=""
                    style="width: 100%; height: 100%; object-fit: cover; "
                    :style="`width: 210px; center center/ cover no-repeat;`"
                  />
                </div>
                <div
                  v-if="['', null].includes(element.menuPic)"
                  class="fs60 pt20"
                  style="color: #cccccc;"
                >
                  <PictureOutlined />
                </div>
              </div>
            </div>
          </template>
        </draggable>
      </div>
      <div class="addPerMenu" @click="() => dealMenu(true, 2, 1)">
        + 添加二级菜单
      </div>
    </div>
  </div>
</template>
<script>
import ImgMenuSet from './ImgMenuSet.vue'
import TextMenuSet from './TextMenuSet.vue'
import { reactive, toRefs, inject } from 'vue'
import draggable from 'vuedraggable'
import {
  PlusOutlined,
  EditOutlined,
  CloseOutlined,
  PictureOutlined,
  LockOutlined
} from '@ant-design/icons-vue'
export default {
  components: {
    draggable,
    PlusOutlined,
    EditOutlined,
    CloseOutlined,
    PictureOutlined,
    LockOutlined,
    ImgMenuSet,
    TextMenuSet
  },
  setup() {
    const init = inject('initState')
    const state = reactive({
      drag: false,
      onDragEnd() {
        state.drag = false
        console.log('拖动结束')
        init.postParams.modify = true
      }
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.dragTitle {
  width: 200px;
  height: 40px;
  text-align: center;
  flex-shrink: 0;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  line-height: 40px;
  margin-right: 4px;
}

.addTab {
  width: 60px;
  height: 40px;
  font-size: 16px;
  text-align: center;
  flex-shrink: 0;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  line-height: 40px;
  cursor: pointer;
}

.dragSon {
  height: 40px;
  text-align: center;
  flex-shrink: 0;
  border: 1px solid #f0f0f0;
  background: #ffffff;
  line-height: 40px;
  margin-bottom: 4px;
}

.addThreeLevel {
  height: 40px;
  text-align: center;
  flex-shrink: 0;
  border: 1px dashed #d9d9d9;
  background: #ffffff;
  line-height: 40px;
  margin-bottom: 4px;
}

.dragTitle.active {
  background: #ffffff;
}

.dragList {
  width: 230px;
  padding: 10px;
  text-align: center;
  flex-shrink: 0;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  line-height: 40px;
  margin-right: 10px;
}

.dragContainer {
  min-width: 1000px;
  min-height: 500px;
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
  margin-top: -1px;
  padding: 10px;
}

input.disBg {
  background: transparent;
  border: none;
}

.icon {
  color: #cccccc;
}

.addPerMenu {
  width: 230px;
  height: 40px;
  text-align: center;
  flex-shrink: 0;
  border: 1px dashed #d9d9d9;
  background: #ffffff;
  line-height: 40px;
  margin-bottom: 4px;
}

.dragTitles {
  overflow-y: hidden;
  overflow-x: scroll;
}

.menuTit {
  display: inline-block;
  width: 160px;
  text-overflow: ellipsis;
  overflow: hidden;
  background: url('https://cdn-image.kapeixi.cn/web/58a793cf-e268-482c-977d-e5c23c0bb011/drag.png')
    0px center / 20px 20px no-repeat;
  cursor: pointer;
}

.addPerMenu.footer {
  width: 200px;
}

.footerCOntainer {
  background: #fafafa;
  padding: 10px;
  margin: 10px;
}

.footerCOntainer .dragTitle {
  background: #ffffff;
}

.footerCOntainer .dragTitle.item {
  background: #fafafa;
  border-color: transparent;
}
</style>
<style>
.navDragMenu .ant-input:focus {
  /* 去除获取焦点时的样式 */
  border: none;
  box-shadow: none;
}
.navDragMenu .ant-input {
  /* 去除边框样式 */
  resize: none;
  border: none;
}
</style>
